<template>
  <div id="app">
    <router-view v-if="userLoaded"></router-view>

    <!--<div v-if="!userLoaded" class="container">
      <div class="col-xs-6 mt-3">
        <div class="alert alert-light text-center" role="alert">
          <h4 class="alert-heading">
            Carregando usuário ...
          </h4>

          <h4>
              <i class="fa fa-circle-o-notch fa-spin text-info"></i>
          </h4>

          <hr>

          <p class="mb-0">Assim que estiver pronto iremos redirecionar você.</p>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import AuthError from './Errors/Auth';
import swal from "sweetalert2";

export default {
  name: 'app',

  data() {
    return {
      userLoaded: false,
      newPluggtoCode: false,
    }
  },

  created() {
    this.saveCookies()
  },

  computed: mapGetters({
    user: 'getUserObject',
    currentPluggtocode: 'currentPluggtocode',
  }),

  methods: {
    ...mapMutations([
      'USER_OBJECT',
      'USER_APP_TOKEN',
      'SET_PLUGGTOCODE'
    ]),
    saveCookies() {
      if (this.currentPluggtocode) {
        if (this.$route.query.pluggtocode && this.currentPluggtocode != this.$route.query.pluggtocode) {
          this.SET_PLUGGTOCODE(this.$route.query.pluggtocode)

          this.newPluggtoCode = true;
          this.USER_APP_TOKEN({
            token: ''
          });

          this.USER_OBJECT({
            pluggToUserId: null,
            pluggToEmail: null,
            pluggToName: null,
            pluggToSubuser: null,
            pluggToTokens: {
              accessToken: null,
              refreshToken: null,
              expireAt: null,
            },
            createdAt: null,
            pluggToErpDefault: null,
            marketplace:null
          });
        }
        this.verifyRefreshToken()

      } else {
        this.SET_PLUGGTOCODE(this.$route.query.pluggtocode)
        this.verifyRefreshToken()
      }
    },
    locationUrl(pathname) {
      const url = new URL(window.location.href);
      return url.pathname == pathname;
    },
    verifyRefreshToken() {
      if (this.user.token && this.newPluggtoCode == false) {
        this.$http.get('/api/refresh/token').then((response) => {

          this.userLoaded = true;

          if (this.$route.name == 'home') {
            if (this.locationUrl('/expedition'))
              this.$router.push({ name: 'expedition' });
            else
              this.$router.push({ name: 'dashboard' });
          }
        }).catch((error) => {

        });
      } else {
        this.getUserDataWithPluggToCode()
      }
    },

    getUserDataWithPluggToCode() {
      this.$http.post('/api/pluggtocode', {
        pluggtocode: this.currentPluggtocode
      }).then(response => {
        if(response.data.isBetaUser) {
          document.location.href = 'https://orders-stage.plugg.to/?pluggtocode=' + this.currentPluggtocode;
        }
        this.USER_OBJECT({
          pluggToUserId: response.data.user.id,
          pluggToEmail: response.data.user.email,
          pluggToName: response.data.user.name,
          pluggToSubuser: response.data.user.subuser || {},
          pluggToTokens: {
            accessToken: response.data.tokens.access_token,
            refreshToken: response.data.tokens.refresh_token,
            expireAt: response.data.tokens.expires_in
          },
          createdAt: '',
          pluggToErpDefault: response.data.user.erp_default,
          marketplace: response.data.user.marketplace
        });

        this.registerUser({
          pluggto_user_name: response.data.user.name,
          pluggto_user_email: response.data.user.email,
          subuser_id: (response.data.user.subuser && !response.data.user.subuser.isAdmin ? response.data.user.subuser.id : null),
          admin_user_id: (response.data.user.subuser && response.data.user.subuser.isAdmin ? response.data.user.subuser.id : null),
          password: response.data.user.email,
          password_confirmation: response.data.user.email,
          pluggto_user_id: response.data.user.id,
          access_token: response.data.tokens.access_token,
          refresh_token: response.data.tokens.refresh_token,
          expires_in: response.data.tokens.expires_in,
          marketplace: response.data.user.marketplace
        });
      }, (error) => {
        swal({
          title: "Ops!",
          text: "Não conseguimos encontrar o usuário. Recarregue a página e tente novamente.",
          type: "error",
          closeOnConfirm: false,
          closeOnCancel: false,
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false,
        })
      });
    },


    registerUser(user) {
      this.$http.post('/api/registered', {
            pluggto_user_id: user.pluggto_user_id,
            admin_user_id: user.admin_user_id,
            subuser_id: user.subuser_id,
            marketplace: user.marketplace
        }).then(response => {
        if (response.data == 0) {
          this.$http.post('/api/register', user).then(response => {
            this.loginUser({
              pluggto_user_email: user.pluggto_user_email,
              subuser_id: user.subuser_id,
              admin_user_id: user.admin_user_id,
              password: user.pluggto_user_email,
              marketplace: user.marketplace
            });
          });
        } else {
          this.loginUser({
            pluggto_user_email: user.pluggto_user_email,
            subuser_id: user.subuser_id,
            admin_user_id: user.admin_user_id,
            password: user.pluggto_user_email,
            marketplace: user.marketplace
          });
        }
      });
    },

    loginUser(user) {
      this.$http.post('/api/login', user).then(({ data }) => {
        this.USER_APP_TOKEN({
          token: data.token
        });

        this.userLoaded = true;

        if (this.locationUrl('/expedition'))
          this.$router.push({ name: 'expedition' });
        else
          this.$router.push({ name: 'dashboard' });
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue